/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { O as Orientation } from './constants-c94b83bd.js';
import { D as DHL_HEADLINE } from './constants-366d7065.js';

const DHL_COPY_TEXT_CONTENT_TEXT_ALIGN = {
    LEFT: Orientation.left,
    CENTER: Orientation.center,
    RIGHT: Orientation.right,
};
const DHL_COPY_TEXT = {
    CONTENT_TEXT_ALIGN: DHL_COPY_TEXT_CONTENT_TEXT_ALIGN,
    HEADLINE_COLOR: DHL_HEADLINE.COLOR,
    HEADLINE_TAG: DHL_HEADLINE.TAG,
    HEADLINE_LEVEL: DHL_HEADLINE.DESIGN_LEVEL,
    HEADLINE_TEXT_ALIGN: DHL_HEADLINE.TEXT_ALIGN,
    HEADLINE_TEXT_TRANSFORM: DHL_HEADLINE.TEXT_TRANSFORM,
};

export { DHL_COPY_TEXT as D };

//# sourceMappingURL=constants-73bd9cdb.js.map